'use client';

import React from 'react';
import { useTranslation } from '@/lib/i18n/useTranslation';
import { LOCALE_META } from '@/lib/i18n/config';

export default function LanguageToggle({ className = '' }) {
    const { locale, setLocale, hydrated } = useTranslation();
    const next = locale === 'de' ? 'en' : 'de';

    return (
        <button
            type="button"
            onClick={() => setLocale(next)}
            aria-label={LOCALE_META[next].switchLabel}
            title={LOCALE_META[next].switchLabel}
            className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] font-light text-neutral-500 hover:text-neutral-900 transition-colors focus:outline-none focus-visible:text-neutral-900 ${className}`}
            style={{ opacity: hydrated ? 1 : 0 }}
        >
            <span className={locale === 'de' ? 'text-neutral-900' : ''}>de</span>
            <span aria-hidden className="text-neutral-300">/</span>
            <span className={locale === 'en' ? 'text-neutral-900' : ''}>en</span>
        </button>
    );
}
